import { useCallback } from 'react'

import { api } from 'app/api'
import { POST_ENCASHMENT_ACTION, convertParams, convertResult } from 'app/common/api/requests/food/encashment/post'
import { EncashmentsAction, EncashmentsStatusAction, isEncashmentionAction } from 'app/dataTypes/reports/data/finances/encashments/action'


const getErrorText = (action: EncashmentsStatusAction['action'], salePointId: string) => {
  if (action === EncashmentsAction.Accept) {
    return `Не удалось подтвердить принятие наличных для заведения с идентификатором ${salePointId}`
  }
  if (action === EncashmentsAction.Reject) {
    return `Не удалось сделать отказ принятия наличных для заведения с идентификатором ${salePointId}`
  }

  return 'Неизвестная ошибка в запросе POST_ENCASHMENT_ACTION'
}

export function useEncashmentsAction() {

  const handleAction = useCallback(async (params: EncashmentsStatusAction) => {
    if (!isEncashmentionAction(params)) return false

    const res = await api.request(POST_ENCASHMENT_ACTION, {
      error: () => getErrorText(params.action, params.salePointId),
      params,
      convertions: {
        convertParams,
        convertResult,
      },
    })


    return res
  }, [])

  return handleAction
}
